import { APP_INITIALIZER, NgModule, provideZonelessChangeDetection } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRouting } from "./app.routing";
import { AppComponent } from "./app.component";
import { BreadcrumbComponentModule } from "../../../commons/src/lib/components/breadcrumbs/route-breadcrumb/route-breadcrumb-component.module";
import { HeaderComponentModule } from "../../../commons/src/lib/components/header/header-component.module";
import { LoadingComponentModule } from "../../../commons/src/lib/components/loading/loading-component.module";
import { SidenavComponentModule } from "../../../commons/src/lib/components/sidenav/sidenav-component.module";
import { HeadersInterceptor } from "../../../commons/src/lib/interceptors/headers.interceptor";
import { KeycloakModule } from "../../../commons/src/lib/modules/keycloak.module";
import { environment } from "../environments/environment";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { PRECONNECT_CHECK_BLOCKLIST } from "@angular/common";
import { InterpolatableTranslationObject, TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { RegionalTranslateLoader } from "../../../commons/src/lib/i18n/regional-translate-loader";

export function appInitializerFactory(translate: TranslateService): () => Observable<InterpolatableTranslationObject> {
  return (): Observable<InterpolatableTranslationObject> => {
    const defaultLang = "es-cl";
    translate.setDefaultLang(defaultLang);
    return translate.use(defaultLang);
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    KeycloakModule.forRoot(environment),
    AppRouting,
    HeaderComponentModule,
    BreadcrumbComponentModule,
    LoadingComponentModule,
    SidenavComponentModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: RegionalTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true,
    },
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    {
      provide: PRECONNECT_CHECK_BLOCKLIST,
      useValue: ["https://storage.googleapis.com/stcx-dgsp-file-manager-uat/sertec", "https://sertec-uat.falabella.com"],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
